import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const Content = ({ content, largeFont }) => {
  return (
    <section className={`content${largeFont ? ' content--large' : ''}`}>
      <Fade distance='40px' bottom>
        <div className="content__inner">
          { content && <div className="content__content">{parse(content)}</div> }
        </div>
      </Fade>
    </section>
  )
}

export default Content
